import { ButtonProps, Box, Button } from '@cad-arc';
import { useOpenBoloPanel } from './use-open-bolo-panel';

export const NewBoloButton = (props: ButtonProps): React.ReactElement => {
    const openBoloPanel = useOpenBoloPanel();
    return (
        <Box ml="10">
            <Button
                leadingVisual="Add"
                type="button"
                size="sm"
                variant="outline"
                onClick={() => {
                    openBoloPanel({});
                }}
                {...props}
            >
                New BOLO
            </Button>
        </Box>
    );
};
